Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaRootInstance = exports.validateSchemaRoots = exports.isSchemaRoot = void 0;
const registry_1 = require("./registry");
const error_1 = require("./error");
function hasDuplicates(arr) {
    return new Set(arr).size !== arr.length;
}
function isSchemaRoot(base) {
    return registry_1.schemaRootsRegistry.has(base);
}
exports.isSchemaRoot = isSchemaRoot;
function validateSchemaRoots(roots) {
    if (hasDuplicates(roots)) {
        throw new error_1.SchemaCompilationError(`At least one schema root is provided more than once in schema roots`);
    }
    for (const root of roots) {
        if (!registry_1.schemaRootsRegistry.has(root)) {
            throw new error_1.SchemaRootError(root, `Schema root must be registered with @SchemaRoot`);
        }
    }
}
exports.validateSchemaRoots = validateSchemaRoots;
const schemaRootInstances = new WeakMap();
function getSchemaRootInstance(schemaRootClass) {
    if (!isSchemaRoot(schemaRootClass)) {
        return null;
    }
    if (schemaRootInstances.has(schemaRootClass)) {
        return schemaRootInstances.get(schemaRootClass);
    }
    const instance = new schemaRootClass();
    schemaRootInstances.set(schemaRootClass, instance);
    return instance;
}
exports.getSchemaRootInstance = getSchemaRootInstance;
//# sourceMappingURL=services.js.map